import { InjectionToken } from "@angular/core";

export const MODAL_DATA = new InjectionToken<any>('MODAL_DATA');



// WEBPACK FOOTER //
// ./ts/app/shared/tokens/modal-data.token.ts